// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__evsp-","info":"UpdateTermsInfo_info__32e31"};